var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 3.125C6.3904 3.125 6.12545 3.23475 5.9301 3.4301C5.73475 3.62545 5.625 3.8904 5.625 4.16667V15.8333C5.625 16.1096 5.73475 16.3746 5.9301 16.5699C6.12545 16.7653 6.3904 16.875 6.66667 16.875H13.3333C13.6096 16.875 13.8746 16.7653 14.0699 16.5699C14.2653 16.3746 14.375 16.1096 14.375 15.8333V4.16667C14.375 3.8904 14.2653 3.62545 14.0699 3.4301C13.8746 3.23475 13.6096 3.125 13.3333 3.125H11.4228C11.4458 3.19016 11.4583 3.26028 11.4583 3.33333C11.4583 3.67851 11.1785 3.95833 10.8333 3.95833H9.16667C8.82149 3.95833 8.54167 3.67851 8.54167 3.33333C8.54167 3.26028 8.5542 3.19016 8.57723 3.125H6.66667ZM5.04621 2.54621C5.47598 2.11644 6.05888 1.875 6.66667 1.875H13.3333C13.9411 1.875 14.524 2.11644 14.9538 2.54621C15.3836 2.97598 15.625 3.55888 15.625 4.16667V15.8333C15.625 16.4411 15.3836 17.024 14.9538 17.4538C14.524 17.8836 13.9411 18.125 13.3333 18.125H6.66667C6.05888 18.125 5.47598 17.8836 5.04621 17.4538C4.61644 17.024 4.375 16.4411 4.375 15.8333V4.16667C4.375 3.55888 4.61644 2.97598 5.04621 2.54621ZM10.625 14.1667C10.625 13.8215 10.3452 13.5417 10 13.5417C9.65482 13.5417 9.375 13.8215 9.375 14.1667V14.175C9.375 14.5202 9.65482 14.8 10 14.8C10.3452 14.8 10.625 14.5202 10.625 14.175V14.1667Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.f7983dea93858261854492cf6b236a36.svg";
export { ForwardRef as ReactComponent };